/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentType {
    OnDelivery = 0,
    Klarna = 1,
}